<template>
  <treeselect
    :multiple="false"
    :options="investiment"
    :show-count="true"
    :searchable="false"
    :clearable="false"
    placeholder="Selecione seu investimento"
    v-model="select_investment_id"
    @select="selectInvestment"
    class="h-10"
  >
    <div slot="option-label" slot-scope="{ node, labelClassName }" :class="labelClassName" class="py-2">
      <div class="flex items-center justify-between" v-for="(item, index) in list_investment" :key="index">
        <div class="space-x-3" v-if="node.id == item.investment_id">
          <span
            v-show="item.investment_id != 0"
            class="relative -mb-3 inline-flex h-3 w-3 items-center"
            :content="
              item.investment_status === 'STOPPED'
                ? 'Investimento parado'
                : item.investment_status === 'RUNNING'
                  ? 'Investimento em execução'
                  : 'Investimento arquivado'
            "
            v-tippy="{
              arrow: true,
              theme:
                item.investment_status === 'STOPPED' ? 'red' : item.investment_status === 'RUNNING' ? 'green' : 'gray',
            }"
          >
            <span
              :class="
                item.investment_status == 'STOPPED'
                  ? 'bg-ontick-red-500'
                  : item.investment_status == 'RUNNING'
                    ? 'bg-ontick-green-500 animate-ping'
                    : 'bg-gray-400'
              "
              class="absolute inline-flex h-full w-full rounded-full opacity-75"
            ></span>

            <span
              class="relative inline-flex h-3 w-3 rounded-full"
              :class="
                item.investment_status == 'STOPPED'
                  ? 'bg-ontick-red-500'
                  : item.investment_status == 'RUNNING'
                    ? 'bg-ontick-green-500'
                    : 'bg-gray-400'
              "
            ></span>
          </span>
          <!-- <span class="text-ontick-blue-500 inline-flex text-sm">{{
            item.investment_id
          }}</span> -->
          <span v-if="item.investment_id != 0" class="text-ontick-blue-500 inline-flex text-sm">{{ node.id }}</span>
          <span class="text-ontick-steel-900 text-sm dark:text-gray-300">{{ node.label }}</span>
        </div>
        <div
          class="text-ontick-steel-900 float-right ml-2 text-sm dark:text-gray-300"
          v-if="node.id == item.investment_id"
        >
          <div
            content="Ordens executadas"
            v-tippy="{ arrow: true, theme: 'green' }"
            v-show="item.investment_status != 'HIDDEN'"
            class="mx-2 inline-flex items-center"
          >
            <p class="mx-2">{{ item.num_positions }}</p>
          </div>
        </div>
      </div>
    </div>
    <div slot="value-label" slot-scope="{ node }" class="w-full">
      <div class="flex items-center justify-between" v-for="(item, index) in list_investment" :key="index">
        <div class="space-x-3" v-if="node.id == item.investment_id">
          <span
            v-if="item.investment_id != 0"
            class="relative -mb-3 inline-flex h-3 w-3 items-center"
            :content="
              item.investment_status === 'STOPPED'
                ? 'Investimento parado'
                : item.investment_status === 'RUNNING'
                  ? 'Investimento em execução'
                  : 'Investimento arquivado'
            "
            v-tippy="{
              arrow: true,
              theme:
                item.investment_status === 'STOPPED' ? 'red' : item.investment_status === 'RUNNING' ? 'green' : 'gray',
            }"
          >
            <span
              :class="
                item.investment_status == 'STOPPED'
                  ? 'bg-ontick-red-500'
                  : item.investment_status == 'RUNNING'
                    ? 'bg-ontick-green-500 animate-ping'
                    : 'bg-gray-400'
              "
              class="absolute inline-flex h-full w-full rounded-full opacity-75"
            ></span>

            <span
              class="relative inline-flex h-3 w-3 rounded-full"
              :class="
                item.investment_status == 'STOPPED'
                  ? 'bg-ontick-red-500'
                  : item.investment_status == 'RUNNING'
                    ? 'bg-ontick-green-500'
                    : 'bg-gray-400'
              "
            ></span>
          </span>
          <span v-if="item.investment_id != 0" class="text-ontick-blue-500 inline-flex text-sm">{{
            item.investment_id
          }}</span>
          <span class="text-ontick-steel-900 text-sm dark:text-gray-300">{{ node.label }}</span>
        </div>
        <div
          class="text-ontick-steel-900 float-right ml-2 text-sm dark:text-gray-300"
          v-if="node.id == item.investment_id"
        >
          <div
            content="Ordens executadas"
            v-tippy="{ arrow: true, theme: 'green' }"
            v-show="item.investment_status != 'HIDDEN'"
            class="mx-2 inline-flex items-center"
          >
            <p class="text-ontick-steel-900 mx-2 dark:text-gray-300">
              {{ item.num_positions }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </treeselect>
</template>

<script>
import { mapActions } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

export default {
  name: "chart-header",
  components: {
    Treeselect,
    VueCtkDateTimePicker,
    menuMobile: () => import("./chart-header-mobile.component.vue"),
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
    select_investment_id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      investiment: [],
      list_investment: [],
      select_investment: {},
      // select_investment_id: 0,
      range: true,
    };
  },

  created() {
    this.initListInvestment(this.data);
  },
  methods: {
    ...mapActions({
      toggleAccount: "performance/toggleAccount",
    }),

    initListInvestment(value) {
      let investiment_array = [];
      let order_by = { stopped: [], running: [], hidden: [] };

      investiment_array.push({
        investment_id: 0,
        investment_name: "Selecione uma estratégia",
      });
      value.accounts.forEach((item_account) => {
        item_account.investments.forEach((item) => {
          investiment_array.push(item);
          let new_investment;
          if (item.investment_status == "STOPPED") {
            new_investment = {
              label: item.investment_name,
              id: item.investment_id,
            };

            order_by.stopped.push(new_investment);
          } else if (item.investment_status == "RUNNING") {
            new_investment = {
              label: item.investment_name,
              id: item.investment_id,
            };

            order_by.running.push(new_investment);
          } else {
            new_investment = {
              label: item.investment_name,
              id: item.investment_id,
            };

            order_by.hidden.push(new_investment);
          }
        });
      });

      // this.investiment = order_by.running.concat(
      //   order_by.stopped,
      //   order_by.hidden
      // );
      this.investiment = [
        {
          id: 0,
          label: "Selecione uma estratégia",
        },
        ...order_by.running,
        ...order_by.stopped,
        ...order_by.hidden,
      ];

      const investmentIndex = this.investiment.findIndex((item) => item.id === this.select_investment_id);

      this.select_investment = this.investiment[investmentIndex];
      // this.select_investment_id = this.investiment[0].id;
      this.list_investment = investiment_array;

      this.selectInvestment(this.select_investment);
    },

    selectInvestment(investment) {
      this.select_investment = investment;
      let data_investment = {};

      let index = this.list_investment.findIndex((item) => item.investment_id == investment.id);
      if (index != -1) {
        data_investment = this.list_investment[index];
      }

      this.$emit("listInvestment", { ...data_investment });
    },
  },

  watch: {
    data(value) {
      this.initListInvestment(value);
      return value;
    },
  },

  unmounted: function () {
    this.investiment = [];
  },
};
</script>

<style lang="scss">
@import "./chart-header.component.scss";
</style>
